import { makeStyles, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      width: '100%'
    },
    input: {
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    textArea: {
      ...theme.scrollStyles,
      border: '2px solid',
      borderRadius: '4px',
      padding: '.45rem .15rem .45rem .65rem'
    },
    noError: {
      color: colors.grey.dark,
      borderColor: colors.grey.medium,
      '&:hover': {
        borderColor: colors.accent.main,
        color: colors.accent.main
      },
      '&:focus': {
        borderColor: colors.primary.main,
        color: colors.primary.main,
        backgroundColor: colors.primary.light
      },
      '&:disabled': {
        pointerEvents: 'none',
        backgroundColor: colors.grey.light
      }
    },
    error: {
      ...theme.errorStyles
    }
  };
});

const TextAreaInput = ({ defaultValue, onChange, inputRef, name, rows, error, disabled }) => {
  const classes = useStyles();

  const onValueChange = e => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <TextField
      className={classes.root}
      onChange={onValueChange}
      multiline
      defaultValue={defaultValue}
      rows={rows}
      inputRef={inputRef}
      error={error}
      name={name}
      disabled={disabled}
      InputProps={{
        classes: {
          root: classes.input,
          input: `${classes.textArea} ${error ? classes.error : classes.noError}`
        }
      }}
    />
  );
};

TextAreaInput.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  inputRef: PropTypes.func,
  name: PropTypes.string
};

TextAreaInput.defaultProps = {
  rows: 5,
  error: false,
  disabled: false,
  inputRef: null,
  name: null,
  defaultValue: '',
  onChange: null
};

export default TextAreaInput;
